import startOfWeek from 'date-fns/startOfWeek';

import { storage } from '../compat/storage';

type TrackWatchCountArgs = { userId: number; channelId: number };

// TODO need change structure of stats to Maps
export async function trackWatchCount({ userId, channelId }: TrackWatchCountArgs) {
  const stats = await storage.getWatchStats();

  const userStats = stats[userId];

  const weekStart = startOfWeek(new Date(), { weekStartsOn: 1 }).getTime();

  if (!userStats) {
    stats[userId] = [createStats(channelId, weekStart)];

    return storage.setWatchStats(stats);
  }

  const channelStats = userStats.find((stats) => stats.id === channelId);

  if (!channelStats) {
    userStats.push(createStats(channelId, weekStart));

    return storage.setWatchStats(stats);
  }

  const currentWeekIndex = channelStats.weeks.findIndex((weekStats) => weekStats.weekStartDate === weekStart);

  if (currentWeekIndex === -1) {
    channelStats.weeks.push({
      weekStartDate: weekStart,
      count: 1,
    });

    return storage.setWatchStats(stats);
  }

  channelStats.weeks[currentWeekIndex].count += 1;

  return storage.setWatchStats(stats);
}

function createStats(channelId: number, weekStart: number) {
  return {
    id: channelId,
    weeks: [{ weekStartDate: weekStart, count: 1 }],
  };
}
